import { ButtonType, TertiaryButton } from '@ardoq/button';
import {
  ButtonWithDropdown,
  DropdownItem,
  DropdownOptionType,
} from '@ardoq/dropdown-menu';
import { DropdownSize } from '@ardoq/dropdown-menu-ui';
import { Icon } from '@ardoq/icons';
import { FlexBox } from '@ardoq/layout';
import { TruncatedTextPopover } from '@ardoq/popovers';
import type {
  PriorityViewpointItem,
  ViewpointToolBarButton,
} from './toViewpointToolBarProps';
import { toViewpointDropdownOption } from 'viewpoints/toViewpointDropdownOption';

type ViewpointSelectorButtonProps = {
  viewpointButton: ViewpointToolBarButton;
  priorityViewpointItems: PriorityViewpointItem[];
  seeAllViewpointsLabel: string;
  defaultOverviewLabel: string;
};

const toDropdownItems = (
  priorityViewpointItems: PriorityViewpointItem[],
  onOpenMoreViewpoints: VoidFunction,
  seeAllViewpointsLabel: string,
  defaultOverviewLabel: string
): Partial<DropdownItem>[] => [
  ...priorityViewpointItems.map(item => ({
    ...toViewpointDropdownOption(item, defaultOverviewLabel),
    isSelected: item.isCurrent,
    onClick: item.onSelect,
  })),
  { type: DropdownOptionType.DIVIDER },
  {
    type: DropdownOptionType.OPTION,
    label: seeAllViewpointsLabel,
    onClick: onOpenMoreViewpoints,
  },
];

export const ViewpointSelectorButton = ({
  viewpointButton,
  priorityViewpointItems,
  seeAllViewpointsLabel,
  defaultOverviewLabel,
}: ViewpointSelectorButtonProps) => {
  const buttonContent = (
    <FlexBox maxWidth="200px" paddingX="xsmall" gap="xsmall" align="center">
      <Icon iconName={viewpointButton.iconName} />
      <TruncatedTextPopover>{viewpointButton.text}</TruncatedTextPopover>
    </FlexBox>
  );

  if (priorityViewpointItems.length === 0) {
    return (
      <TertiaryButton
        onClick={viewpointButton.onClick}
        isActive={viewpointButton.isActive}
        buttonSize={viewpointButton.buttonSize}
      >
        {buttonContent}
      </TertiaryButton>
    );
  }

  return (
    <ButtonWithDropdown
      buttonType={ButtonType.TERTIARY}
      options={toDropdownItems(
        priorityViewpointItems,
        viewpointButton.onClick,
        seeAllViewpointsLabel,
        defaultOverviewLabel
      )}
      isActive={viewpointButton.isActive}
      buttonSize={viewpointButton.buttonSize}
      maxDropdownSize={DropdownSize.L}
    >
      {buttonContent}
    </ButtonWithDropdown>
  );
};
